import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { getChartData } from "../../services/api/invoice";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/slices/toastSlice";
import { Box, Paper, Typography } from "@mui/material";

// Register the necessary chart components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SalesChart = () => {
  const dispatch = useDispatch();
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const response = await getChartData();
        const data = response.data;

        // Format data for Chart.js
        setChartData({
          labels: data.map((item) => item.month), // Use the month-year as labels
          datasets: [
            {
              label: "Total Rent",
              data: data.map((item) => item.totalRent),
              backgroundColor: "rgba(54, 162, 235, 0.6)",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1,
            },
            {
              label: "Paid Amount",
              data: data.map((item) => item.paidAmount),
              backgroundColor: "rgba(75, 192, 192, 0.6)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
            },
            {
              label: "Overdue Amount",
              data: data.map((item) => item.overdueAmount),
              backgroundColor: "rgba(255, 99, 132, 0.6)",
              borderColor: "rgba(255, 99, 132, 1)",
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        dispatch(showToast({ message: error.message, severity: "error" }));
      }
    };

    fetchInitialData();
  }, []);

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Monthly Rent Data (Total Rent, Overdue, Paid Amount)",
      },
    },
    scales: {
      x: {
        // The x-axis now displays each category side by side for each month
        grouped: true,
      },
      y: {
        beginAtZero: true, // Ensures the y-axis starts at zero
      },
    },
  };

  if (!chartData) return <div>Loading...</div>;

  return (
    <>
      <Typography variant="h5" sx={{ mt: 8, mb: 1 }}>
        Monthly Payment Overview
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: "#999" }}>
        Visualize and analyze your monthly rent payments, overdue amounts, and
        paid amounts with this chart. Stay informed about your financial trends
        and payment statuses.
      </Typography>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          borderRadius: 2,
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            p: 2,
          }}
        >
          <Bar data={chartData} options={options} />
        </Box>
      </Paper>
    </>
  );
};

export default SalesChart;
